module.exports = __webpack_public_path__ + "img/官网-证书-然也信息化教学平台.c42ba542.png";